export const BRIGHTEDGE_AUTOPILOT_GET_REQUEST = 'BRIGHTEDGE_AUTOPILOT_GET_REQUEST';
export const BRIGHTEDGE_AUTOPILOT_GET_SUCCESS = 'BRIGHTEDGE_AUTOPILOT_GET_SUCCESS';
export const BRIGHTEDGE_AUTOPILOT_GET_ERROR = 'BRIGHTEDGE_AUTOPILOT_GET_ERROR';
